var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useRef, useState, } from "react";
import { djRestAuth } from "../api/api";
import { Loading } from "../nav/Loading";
export var UserContext = createContext({
    user: null,
    loading: null,
    setUser: function () { return undefined; },
    setLoading: function () { return undefined; },
});
export var UserProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState(null), 2), user = _b[0], setUser = _b[1];
    var _c = __read(useState(true), 2), loading = _c[0], setLoading = _c[1];
    var isVerifying = useRef(false);
    var verifyToken = useCallback(function () {
        if (isVerifying.current)
            return;
        isVerifying.current = true;
        return djRestAuth
            .post("/token/verify", {})
            .then(function () {
            if (!user) {
                return djRestAuth.get("/user/").then(function (response) {
                    setUser(response.data);
                    setLoading(false);
                });
            }
            return Promise.resolve();
        })
            .catch(function () {
            if (!user) {
                return djRestAuth
                    .get("/user/")
                    .then(function (response) {
                    setUser(response.data);
                    setLoading(false);
                })
                    .catch(function () {
                    setUser(null);
                    setLoading(false);
                });
            }
            return Promise.resolve();
        })
            .finally(function () {
            isVerifying.current = false;
        });
    }, [user]);
    useEffect(function () {
        if (loading && user === null && !isVerifying.current) {
            verifyToken();
        }
    }, [loading, user, verifyToken]);
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsx(UserContext.Provider, { value: { user: user, loading: loading, setUser: setUser, setLoading: setLoading }, children: children }));
};
